import { createInsertSchema } from 'drizzle-zod';
import { z } from 'zod';
export function createAppInsertSchema(table) {
    return createInsertSchema(table).omit({
        id: true,
        orgId: true,
        createdAt: true,
        updatedAt: true,
        createdById: true,
        updatedById: true,
    });
}
export function schemaToModelChange(modelName, schema) {
    return z.union([
        z.object({
            modelName: z.literal(modelName),
            modelId: z.uuid(),
            action: z.literal('create'),
            data: schema,
        }),
        z.object({
            modelName: z.literal(modelName),
            modelId: z.uuid(),
            action: z.literal('update'),
            data: schema.partial(),
        }),
        z.object({
            modelName: z.literal(modelName),
            modelId: z.uuid(),
            action: z.literal('delete'),
        }),
    ]);
}
//# sourceMappingURL=schema.js.map